import styled from 'styled-components';

interface Props {
  onClose: () => void;
}

function ReportModal({ onClose }: Props) {
  return (
    <ModalOverlay
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <ModalContainer
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Header>
          <img
            src="/assets/images/icon/error_gray.svg"
            alt=""
            width={60}
            height={60}
          />
          <Title>리포트 열람 이용권을 모두 사용하셨습니다.</Title>
        </Header>

        <Button onClick={onClose}>확인</Button>
      </ModalContainer>
    </ModalOverlay>
  );
}

export default ReportModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  width: 328px;
  background-color: #ffffff;
  border-radius: 16px;
  padding: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const Button = styled.button`
  width: 100%;
  border-radius: 8px;
  padding: 14px 28px;
  background-color: #008aff;
  border: none;
  cursor: pointer;

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #ffffff;
`;
